<template>
  <el-dialog :title="!dataForm.id ? 'New Protocol' : 'Edit Protocol'" :close-on-click-modal="false" :visible.sync="visible" width="1100px" top="1vh">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="122px">
      <el-form-item label="Protocol Type" prop="type">
        <el-select v-model="dataForm.type" placeholder="Select type" class="wdb100">
          <el-option v-for="item in protocolTypeList" :key="item.value" :label="item.title" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Supplier" prop="supplierId">
        <el-select v-model="dataForm.supplierId" filterable clearable class="wdb100">
          <el-option v-for="item in supplierList" :key="`supplier-${item.id}`" :label="item.companyName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Content" prop="content">
        <el-editor :height="500" type="pure" v-model="dataForm.content" />
      </el-form-item>
      <el-form-item label="File" prop="payNowUen">
        <el-file-uploader v-model="dataForm.fileUrl"></el-file-uploader>
      </el-form-item>
      <el-form-item label="Content(CN)" prop="contentCn">
        <el-editor :height="500" type="pure" v-model="dataForm.contentCn" />
      </el-form-item>
      <el-form-item label="File(CN)" prop="payNowUen">
        <el-file-uploader v-model="dataForm.fileUrlCn"></el-file-uploader>
      </el-form-item>
      <!-- <el-form-item label="Status" prop="status">
        <el-radio-group v-model="dataForm.status">
          <el-radio :label="0">Disable</el-radio>
          <el-radio :label="1">Enable</el-radio>
        </el-radio-group>
      </el-form-item> -->
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">Cancel</el-button>
      <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit()">Submit</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    protocolTypeList: {
      type: Array,
    },
    supplierList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: false,
      dataForm: {
        id: 0,
        type: "",
        content: undefined,
        contentCn: undefined,
        fileUrl: undefined,
        fileUrlCn: undefined,
        supplierId: null,
        status: 1,
      },
      dataRule: {
        type: [{ required: true, message: "please select", trigger: "submit" }],
        supplierId: [{ required: true, message: "please select", trigger: "submit" }],
      },
      submitLoading: false,
    };
  },
  methods: {
    async init(data) {
      this.submitLoading = false;
      this.visible = true;
      await this.$nextTick();
      this.$refs["dataForm"].resetFields();
      if (data) {
        this.dataForm = {
          id: data.id,
          type: data.type,
          content: data.content || undefined,
          contentCn: data.contentCn || undefined,
          fileUrl: data.fileUrl || undefined,
          fileUrlCn: data.fileUrlCn || undefined,
          supplierId: data.supplier?.id,
          status: 1,
        };
      } else {
        this.$set(this.dataForm, "id", null);
      }
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs["dataForm"].validate(async valid => {
        if (valid) {
          this.submitLoading = true;
          this.$http
            .post(this.dataForm.id ? `/admin/stProtocolManage/${this.dataForm.id}/update` : `/admin/stProtocolManage/create`, this.dataForm)
            .then(res => {
              this.$message({
                message: "success",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.visible = false;
                  this.$emit("refreshDataList");
                },
              });
            })
            .catch(err => {
              this.submitLoading = false;
            });
        }
      });
    },
  },
};
</script>
